module.exports = require("core-js/library/fn/object/define-property");


//////////////////
// WEBPACK FOOTER
// ./~/@babel/runtime/core-js/object/define-property.js
// module id = 124
// module chunks = 168707334958949